export const ANCHOR_ICON_WIDTH = "30px"
